var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgFileVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    fillRule: "nonzero",
    d: "M0 0h120v120H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    transform: "translate(26.4 34.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.2,
    height: 50.4,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5D100",
    fillOpacity: 0.3,
    d: "M0 8.4h67.2V42H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 0v7.2M16.8 0v7.2M25.2 0v7.2M33.6 0v7.2M42 0v7.2M50.4 0v7.2M58.8 0v7.2M9 43.2v7.2m8.4-7.2v7.2m8.4-7.2v7.2m8.4-7.2v7.2m8.4-7.2v7.2m8.4-7.2v7.2m8.4-7.2v7.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39 25.2 30.6 30v-9.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFileVideo);
export default __webpack_public_path__ + "static/media/img-file-video.c680a741a74a73f3f00038275611975a.svg";
export { ForwardRef as ReactComponent };